
import Checkbox from '@marketplace/components/forms/inputs/checkbox.vue'
import InputTextarea from '@marketplace/components/forms/inputs/input-textarea.vue'
import AnimatedCheckmark from '@marketplace/components/shared/animations/animated-checkmark.vue'
import { STOREFRONT_FEEDBACK_CREATE_MUTATION } from '@marketplace/graphql/feedback.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'

export default {
    name: 'ModalFeedback',

    components: {
        Checkbox,
        InputTextarea,
        AnimatedCheckmark,
    },

    props: {
        storefrontName: {
            type: String,
            required: true,
        },
        storefrontId: {
            type: String,
            required: true,
        },
        listingId: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            questions: [
                {
                    label: this.$t('modal.feedback.question_1'),
                    value: false,
                },
                {
                    label: this.$t('modal.feedback.question_2'),
                    value: false,
                },
                {
                    label: this.$t('modal.feedback.question_3'),
                    value: false,
                },
            ],
            message: '',
            thankyou: false,
        }
    },

    computed: {
        disabled() {
            if (
                this.questions.some((el) => el.value) &&
                this.message.length >= 5
            ) {
                return false
            }
            return true
        },
        storefrontFeedbackCreateInput() {
            return {
                storefrontId: this.storefrontId,
                hasIncompleteCatalog: this.questions[0].value,
                hasIncorrectPrices: this.questions[1].value,
                hasIncompleteDescription: this.questions[2].value,
                message: this.message,
                listingId: this.listingId,
            }
        },
    },

    methods: {
        handleClick() {
            this.$apollo
                .mutate({
                    mutation: STOREFRONT_FEEDBACK_CREATE_MUTATION,
                    variables: {
                        storefrontFeedbackCreateInput:
                            this.storefrontFeedbackCreateInput,
                    },
                })
                .then(() => {
                    this.thankyou = true
                    setTimeout(() => {
                        EventBus.$emit('modal-close')
                    }, 2000)
                })
        },
    },
}
